import { WizardSideNav } from "../../../../common/wizard/WizardSideNav";
import { useBidStepLabel, visibleBidSteps, type BidStep } from "./bidWizardSteps";

interface Props {
  currentStep: BidStep;
  navigateToStep: (step: BidStep) => void;
  collectSupplierPrice: boolean;
  espdTravelsWithBid?: boolean;
}

export const BidWizardNav = ({ currentStep, navigateToStep, collectSupplierPrice, espdTravelsWithBid = true }: Props) => (
  <WizardSideNav
    steps={visibleBidSteps(collectSupplierPrice, espdTravelsWithBid)}
    currentStep={currentStep}
    navigateToStep={navigateToStep}
    stepLabel={useBidStepLabel()}
  />
);
